import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getRecentComments } from "../../api/getComments";
import Skeleton from "react-loading-skeleton";

class RecentCommentsContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const results = (data && data.data) || [];
    const { comments = [] } = results;
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && comments.length === 0) {
      return null;
    }
    return render({ comments, loading, failure });
  };
}

export default CreateContainer(getRecentComments, RecentCommentsContainer);
